export default "__VITE_PUBLIC_ASSET__28d537ca__"